
<!-- 生产系统首页 -->
<template>
  <div class="cp_home flex_row apphome">
    <!-- <leftcolumn class="app5760 flex_column" /> -->
    <div class="left flex_column">
      <div class="mybox">
        <div class="title">季度产量</div>
        <div class="box">
          <div id="ps_bar1" class="echarts"></div>
        </div>
      </div>
      <div class="mybox">
        <div class="title">产能负荷-未来15天</div>
        <div class="box">
          <div id="ps_line1" class="echarts"></div>
        </div>
      </div>
      <div class="mybox">
        <div class="title">产品良品率</div>
        <div class="box">
          <div id="yields_line" class="echarts"></div>
        </div>
      </div>
      <div class="mybox">
        <div class="title">单位产品能耗趋势</div>
        <div class="box">
          <div id="ps_bar2" class="echarts"></div>
        </div>
      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">实时状态</div>
          <div class="box realtime">
            <iframe v-if="configurationMap" width="100%" height="100%" :src="configurationMap" frameborder="0"></iframe>
            <!-- <RealTimeStatus></RealTimeStatus> -->
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">主要产品</div>
          <div class="box">
            <ProductIntroduction></ProductIntroduction>
          </div>
        </div>
        <div class="mybox">
          <div class="title">自动化生产线</div>
          <div class="box cxlist">
            <li v-for="(item, index) in cxlist" :key="index">
              <img :src="item.beltlineImg">
              <div class="right">
                <div class="title">{{item.beltlineName}}</div>
                <div class="text">{{item.remark}}</div>
              </div>
            </li>
          </div>
        </div>
      </div>
    </div>
    <div class="right flex_column">
      <div class="mybox">
        <div class="title">订单进度</div>
        <div class="box">
          <OrderProgress></OrderProgress>
        </div>
      </div>
      <div class="mybox">
        <div class="title">待交付订单</div>
        <div class="box ddlist">
          <ol><span>客户</span><span>订货产品</span><span>数量</span><span>应交付日期</span><span>生产状态</span></ol>
          <p v-if="!ddlist.length" style="text-align: center;margin-top: 1rem;">暂无数据</p>
          <ul style="overflow: hidden;">
            <vue-seamless-scroll :data="ddlist" :class-option="{limitMoveNum: 6,direction: 1,step: 0.4,}">
              <li v-for="(item, index) in ddlist" :key="index">
                <span>{{item.customName}}</span>
                <span>{{item.proName}}</span>
                <span>{{item.proNum}}</span>
                <span>{{ new Date(item.payTime).Format("yyyy-MM-dd")}}</span>
                <span :class="item.proSpeed!='100'?'f_yellow':''">{{item.proSpeed}}%</span>
              </li>
            </vue-seamless-scroll>
          </ul>
        </div>
      </div>
      <div class="mybox">
        <div class="title">产能趋势</div>
        <div class="box">
          <div id="cnqs_line" class="echarts"></div>
        </div>
      </div>
      <div class="mybox sc-list">
        <div class="title">生产提示</div>
        <div class="box" style="margin:0.65rem 0;">
          <vue-seamless-scroll class="box" :data="tslist" :class-option="{limitMoveNum: 4,direction: 1,step: 0.4,}">
            <ul class=" tslist">
              <p v-if="!tslist.length" style="text-align: center;margin-top: 1rem;">暂无数据</p>
              <li v-for="(item, index) in tslist" :key="index">
                <span>{{item.eventType}}</span>
                <span>{{item.noteTime}}</span>
                <span>{{item.eventArea+item.eventBody+item.eventContent}}</span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <!-- <rightcolumn class="app5760 flex_column" /> -->

  </div>
</template>

<script>
import api from '@/apis/ProductionSystem'
import vueSeamlessScroll from 'vue-seamless-scroll'

let echarts = require('echarts/lib/echarts')
// import RealTimeStatus from "../../components/RealTimeStatus";//实时状态
import OrderProgress from './OrderProgress' //订单进度
import ProductIntroduction from '../../components/ProductIntroduction' //主要产品

// import leftcolumn from '@/views/CompanyProfile/leftcolumn.vue'
// import rightcolumn from '@/views/CompanyProfile/rightcolumn.vue'

export default {
  components: {
    // RealTimeStatus,
    vueSeamlessScroll,
    OrderProgress,
    ProductIntroduction,
    // leftcolumn,
    // rightcolumn,
  },
  data() {
    return {
      configurationMap: '',
      ddlist: [],
      tslist: [],
      cxlist: [],


      //单位产品能耗趋势
      tendencyData: [],
      //季度产量
      productionData: [[], [], []],

      markLine: [
        {
          type: 'average',
          yAxis: '80',
          lineStyle: { color: '#ff5f8c' },
          label: {
            position: 'end',
            formatter: '高',
            fontSize: 16,
          },
        },
        {
          type: 'average',
          yAxis: '30',
          lineStyle: { color: '#24ffb1' },
          label: {
            position: 'end',
            formatter: '低',
            fontSize: 16,
          },
        },
      ],
    }
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    ps_bar1() {
      let ps_bar1 = echarts.init(document.getElementById('ps_bar1'))
      ps_bar1.setOption({
        color: ['#0c2667', '#24ffb1'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: ['指标', '实际'],
          right: 'center',
          top: 2,
          textStyle: {
            color: '#fff',
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        grid: { left: '2%',right:'0%',top:'15%',bottom:'0%',containLabel: true},
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          show: true,
          axisLine: { show: false },
          splitLine: { show: false },
          axisLabel: { color: this.axisLabelColor, fontSize: this.$echartsFontSize },
          axisTick: { show: false },
          data: this.productionData[0], //['产品5','产品4','产品3','产品2','产品1'],
        },
        series: [
          {
            name: '指标',
            type: 'bar',
            barWidth: '40%',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'right',
                  formatter: ' {c}',
                  color: '#ccd0f2',
                  fontSize: this.$echartsFontSize,
                },
              },
            },
            data: this.productionData[1], //[600,600,600,100,600],
          },
          {
            name: '实际',
            type: 'bar',
            barWidth: '40%',
            barGap: '-100%',
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'insideRight',
                  formatter: '{c}',
                  color: '#0a1d91',
                  fontSize: this.$echartsFontSize,
                  offset: [0, 1],
                  fontWeight: 600,
                },
              },
            },
            data: this.productionData[2], //[90,190,190,390,490],
          },
        ],
      })
    },
    ps_line(id, xAxisData,seriesData, markline) {
      console.log(xAxisData, markline);
      let ps_line = echarts.init(document.getElementById(id))
      ps_line.setOption(
        {
          color:['#00ccff','#24ffb1','#fff45c','#ff5f8c','#ae74f3',],

          tooltip: {
            trigger: 'axis',
            textStyle:{fontSize: this.$echartsFontSize}
          },
          legend: {
            left: 'center', top:2,
            textStyle: {
              color: "#fff",fontSize:this.$echartsFontSize
            },
            itemWidth: 25,itemHeight: 10,
          },
          grid: { left: '1%',right:'4%',top:'22%',bottom:'1%',containLabel: true},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData,//['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
            axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          },
          yAxis: {
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
            axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
            splitLine:{show:true,lineStyle:this.splitLineStyle},
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
          },
          series:seriesData
        }
      )
      this.$common.moveEcharts(xAxisData.length,ps_line);
    },
    ps_bar2() {
      let ps_bar2 = echarts.init(document.getElementById('ps_bar2'))
      ps_bar2.setOption({
        color: ['#00ccff', '#24ffb1', '#fff45c', '#ff5f8c', '#ae74f3','#25a3ac'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          left: 'center',
          top: 2,
          textStyle: {
            color: '#fff',
            fontSize: this.$echartsFontSize,
          },
          itemWidth: 15,
          itemHeight: 5,
        },
        xAxis: {
          type: 'category',
          axisLabel:{textStyle:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},margin:10,interval: 0},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
          ],
        },
        yAxis: {
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
          axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
          splitLine:{show:true,lineStyle:this.splitLineStyle},
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
        },
        grid: { left: '0%',right:'4%',top:'22%',bottom:'0%',containLabel: true},
        series: this.tendencyData,
      })
      
    },
  },
  mounted() {
    //获取实时状态
    api.timestatus().then((res) => {
      if (res.code == 10000) {
        this.configurationMap = res.data.list[0].confUrl
      }
    })
    //最近订单
    api
      .recentorder({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.ddlist = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //生产提示
    api
      .hint({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.tslist = res.data.list
            for (const iterator of this.tslist) {
              switch (iterator.eventType) {
                case 0:
                  iterator.eventType = '安全提示'
                  break
                case 1:
                  iterator.eventType = '管理提示'
                  break
                case 2:
                  iterator.eventType = '能耗突增'
                  break
                case 3:
                  iterator.eventType = '能耗超标'
                  break

                default:
                  iterator.eventType = '其他'
                  break
              }
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //产能趋势
    api
      .capacity({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let datalist = res.data.list
            let xAxisData = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
            let  seriesData = []




            for (const iterator of datalist) {
              seriesData.push(
                {
                  name: iterator.proName,
                  type: 'line',
                  data: [iterator.proName,iterator.oneData,iterator.twoData,iterator.threeData,iterator.fourData,iterator.fiveData,iterator.sixData,iterator.sevenData,iterator.eightData,iterator.nineData,iterator.tenData,iterator.elevenData,iterator.twelveData,]
                }
              )
            }


            this.ps_line('cnqs_line', xAxisData,seriesData) //绘图
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //自动化生产线
    api
      .autoline({
        params: {
          limit: 2,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.cxlist = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //单位产品能耗趋势
    api
      .tendency({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let dataArr = res.data.list

            for (const iterator of dataArr) {
              this.tendencyData.push({
                name: iterator.proName,
                type: 'bar',
                barWidth: '12%',
                itemStyle: {
                  normal: {
                    // color: '#fff45c',
                    barBorderRadius: [12, 12, 0, 0],
                  },
                },
                data: [
                  iterator.oneData,
                  iterator.twoData,
                  iterator.threeData,
                  iterator.fourData,
                  iterator.fiveData,
                  iterator.sixData,
                  iterator.sevenData,
                  iterator.eightData,
                  iterator.nineData,
                  iterator.tenData,
                  iterator.elevenData,
                  iterator.twelveData,
                ],
              })
            }
            this.ps_bar2()
          }
        } else {
          this.$message.error(res.message)
        }
      })

    //产品良品率
    api
      .yields({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let datalist = res.data.list
            let xAxisData = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
            let  seriesData = []
            for (const iterator of datalist) {
              seriesData.push(
                {
                  name: iterator.proName,
                  type: 'line',
                  data: [iterator.proName,iterator.oneData,iterator.twoData,iterator.threeData,iterator.fourData,iterator.fiveData,iterator.sixData,iterator.sevenData,iterator.eightData,iterator.nineData,iterator.tenData,iterator.elevenData,iterator.twelveData,]
                }
              )
            }


            this.ps_line('yields_line',xAxisData,seriesData, this.markLine)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //季度产量

    api
      .production({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let datalist = res.data.list

            for (const iterator of datalist) {
              this.productionData[0].push(iterator.proName)
              this.productionData[1].push(iterator.proData)
              this.productionData[2].push(iterator.proTarget)
            }
            this.ps_bar1()
          }
        } else {
          this.$message.error(res.message)
        }
      })

    //未来15天能耗

    api
      .load({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let xAxisData  = ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15']
            let seriesData = []
            
            for (const iterator of res.data.list) {

              let dataArr = JSON.parse(iterator.data)
              seriesData.push(
                {
                  name: iterator.proName,
                  type: 'line',
                  data: dataArr
                }
              )
            }

            this.ps_line('ps_line1',xAxisData,seriesData)
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
}
</script>

<style lang="less" scoped>
.cp_home {
  .box {
    padding: 0.3rem;
  }
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  .realtime {
    position: relative;
  }
  .ddlist {
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    li,
    ol {
      //  flex: 1;
      padding: 0.5rem 15px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(1) {
        flex: 1;
      }
      span:nth-child(2) {
        width: 5rem;
        text-align: center;
      }
      span:nth-child(3) {
        width: 4rem;
        text-align: center;
      }
      span:nth-child(4) {
        width: 5rem;
        text-align: center;
      }
      span:nth-child(5) {
        width: 4rem;
        text-align: center;
      }
    }
    li:nth-child(even) {
      background: #ffffff10;
    }
    ol {
      span {
        text-align: center;
        color: #ccd0f2;
        opacity: 0.8;
      }
    }
  }
  .tslist {
    display: flex;
    flex-direction: column;
    //  padding:10px 15px;
    li {
      //  flex: 1;
      padding: 0.5rem 15px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(1) {
        width: 4rem;
      }
      span:nth-child(2) {
        width: 8rem;
      }
      span:nth-child(3) {
        flex: 1;
      }
    }
    li:nth-child(even) {
      background: #ffffff10;
    }
  }
  .cxlist {
    display: flex;
    flex-direction: row;
    padding: 0.4rem;
    flex-wrap: wrap;
    li {
      flex: 1;
      width: 50%;
      height: 100%;
      padding: 0.3rem 0;
      margin: 0 0.3rem;
      display: flex;
      flex-direction: row;
      img {
        height: 100%;
        width: 11rem;
        margin-right: 0.6rem;
      }
      .right {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 0.8rem;
          margin: 0.3rem 0 0.4rem;
          color: #05f8fc;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .text {
          flex: 1;
          height: 100%;
          line-height: 1rem;
          overflow: hidden;
          text-indent: 1.5rem;
        }
      }
    }
    li:first-child {
      margin-right: 2rem;
    }
  }
}
</style>
